import { useMemo } from "react";

/**
 * SegmentTimer — bordo a segmenti (design_guidelines.json).
 * I segmenti "rimanenti" sono brand (#32D74B), quelli consumati brand-dim (#13381A),
 * consumati in senso orario a partire dall'angolo alto-sinistra.
 *
 * FASE 2: puramente visivo. `progress` = 1 (bordo pieno). Il conto alla rovescia
 * dei 10s che pilota i turni sarà collegato in Fase 4 (Gameplay), senza cambiare
 * la durata del timer definita nel motore.
 */
export const SegmentTimer = ({ progress = 1, config = { top: 12, right: 22, bottom: 12, left: 22 } }) => {
  const { top, right, bottom, left } = config;
  const total = top + right + bottom + left;
  const elapsed = Math.round((1 - Math.min(1, Math.max(0, progress))) * total);

  // Indici globali in senso orario: top → right → bottom → left.
  const sides = useMemo(() => {
    let i = 0;
    const build = (count) => Array.from({ length: count }, () => i++);
    const topIdx = build(top);
    const rightIdx = build(right);
    const bottomIdx = build(bottom);
    const leftIdx = build(left);
    return { topIdx, rightIdx, bottomIdx, leftIdx };
  }, [top, right, bottom, left]);

  const seg = (globalIndex) => (
    <span
      key={globalIndex}
      className={`segtimer__seg${globalIndex < elapsed ? " segtimer__seg--dim" : ""}`}
    />
  );

  return (
    <div className="segtimer" aria-hidden="true">
      <div className="segtimer__side segtimer__side--top">{sides.topIdx.map(seg)}</div>
      <div className="segtimer__side segtimer__side--right">{sides.rightIdx.map(seg)}</div>
      <div className="segtimer__side segtimer__side--bottom">{sides.bottomIdx.map(seg)}</div>
      <div className="segtimer__side segtimer__side--left">{sides.leftIdx.map(seg)}</div>
    </div>
  );
};
